export enum CricketSubParticipantStatId {
  CurrentOverRuns = 582,
  FirstBall = 583,
  SecondBall = 584,
  ThirdBall = 585,
  FourthBall = 586,
  FifthBall = 587,
  SixthBall = 588,
  Appearance = 35,
  WillNotPlay = 1239,
  SeventhBall = 1241,
  EighthBall = 1242,
  NinthBall = 1243,
  TenthBall = 1244,
  EleventhBall = 1245,
  TwelfthBall = 1246,
  CurrentBatter = 1444,
  CurrentBowler = 1443,
  BatScore = 1450,
  Fifty = 1451,
  Hundred = 1452,
  BallsFaced = 1453,
  BatSR = 1454,
  BallsBowled = 1455,
  RunsConceded = 1456,
  BowlerWkts = 1457,
  Maiden = 1458,
  DotBalls = 1459,
  FourConceded = 1460,
  SixConceded = 1461,
  WidesBowled = 1462,
  NoBallsBowled = 1463,
  MVP = 1464,
  NumberOfOvers = 576,
  Fours = 577,
  Sixes = 578,
  StrikingRate = 580,
  NumberOfBalls = 581,
}
